import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

// ICONS
import BulkSendIcon from '../icons/BulkSendIcon';
import ComposeIcon from '../icons/ComposeIcon';
import ContactIcon from '../icons/ContactIcon';
import MessagesIcon from '../icons/MessagesIcon';
import ScheduleIcon from '../icons/ScheduleIcon';
import SearchIcon from '../icons/SearchIcon';
import SettingsIcon from '../icons/SettingsIcon';
import UserListIcon from '../icons/UserListIcon';

export default function SectionWrapper({ title, icon, children, sx }) {
  const iconChoices = {
    bulkSend: <BulkSendIcon sx={{ width: '100%', height: '100%' }} />,
    compose: <ComposeIcon sx={{ width: '100%', height: '100%' }} />,
    contact: <ContactIcon sx={{ width: '100%', height: '100%' }} />,
    messages: <MessagesIcon sx={{ width: '100%', height: '100%' }} />,
    schedule: <ScheduleIcon sx={{ width: '100%', height: '100%' }} />,
    search: <SearchIcon sx={{ width: '100%', height: '100%' }} />,
    settings: <SettingsIcon sx={{ width: '100%', height: '100%' }} />,
    userlist: <UserListIcon sx={{ width: '100%', height: '100%' }} />,
  };

  return (
    <Paper
      sx={{
        borderRadius: 4,
        width: '100%',
        paddingX: 4,
        paddingY: 2,
        position: 'relative',
        ...sx,
      }}
      elevation={0}
    >
      <Box
        sx={{
          color: 'grey.200',
          position: 'absolute',
          top: 4,
          left: -8,
          width: 52,
          height: 52,
          zIndex: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
        }}
      >
        {iconChoices[icon]}
      </Box>

      <Box sx={{ position: 'relative', zIndex: 1 }}>
        <Typography variant="h2" gutterBottom>
          {title}
        </Typography>
        {children}
      </Box>
    </Paper>
  );
}
